var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08073 6.91927H9.91406C11.5249 6.91927 12.8307 5.61343 12.8307 4.0026C12.8307 2.39177 11.5249 1.08594 9.91406 1.08594H4.08073M4.08073 6.91927C2.4699 6.91927 1.16406 5.61343 1.16406 4.0026C1.16406 2.39177 2.4699 1.08594 4.08073 1.08594M4.08073 6.91927C5.69156 6.91927 6.9974 5.61343 6.9974 4.0026C6.9974 2.39177 5.69156 1.08594 4.08073 1.08594",
    stroke: "#808795",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.b72d8b329f5e7ac97d23b094c8b36ed2.svg";
export { ForwardRef as ReactComponent };